export default __webpack_public_path__ + "static/media/38.b4dd1514.png";